export enum PriceAdjustmentType {
  Undefined = 0,
  Percentage = 1,
  Flat = 2,
}
